const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const LoadState = require("../../core/vault/util/LoadState");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const Information = require("../../office/checkout/Information");
const BookstoreUtil = require("../../../shared/BookstoreUtil");
const EditPencil = require("../../office/EditPencil");
const OfficeModal = require("../../office/modals/OfficeModal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const LoadingCircle = require("../../core/view/LoadingCircle");

const styles = require("./styles/EditableAddressCard.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "EditableAddress",

		propTypes: {
			className: PT.string,
			initialAddress: PT.object.isRequired,
			addressType: PT.string,
			onUpdate: PT.func,
			startOpen: PT.bool,
		},

		vaultEvents: {
			parentFormSuccess: function() {
				this.setState({
					isLoading: false,
					isModalOpen: false,
					validation: null,
					invalidAddressGroup: false,
					errorMessage: null,
				});
			},
			parentFormValidationFail: function(validation) {
				this.setState({
					isLoading: false,
					validation,
				});
			},
			parentFormFail: function(error) {
				let invalidAddressGroup = false;
				let errorMessage = null;
				if (error === "E_ADDRESS_NOT_VERIFIED") {
					invalidAddressGroup = true;
				} else if (LoadState.shouldRetry(error)) {
					errorMessage =
						"There was an issue connecting to the server. Please try again.";
				} else {
					errorMessage =
						"There was an issue saving your address. Please try again.";
				}
				this.setState({
					isLoading: false,
					invalidAddressGroup,
					errorMessage,
				});
			},
		},

		getInitialState: function() {
			return {
				isLoading: false,
				isModalOpen: this.props.startOpen || false,
				address: this.props.initialAddress,
				validation: null,
				invalidAddressGroup: false,
				errorMessage: null,
			};
		},

		openModal: function() {
			this.setState({
				isModalOpen: true,
				validation: null,
				invalidAddressGroup: false,
				errorMessage: null,
			});
		},

		closeModal: function() {
			this.setState(_.extend(this.getInitialState(), {isModalOpen: false}));
		},

		updateField: function(field, val) {
			const newAddress = _.clone(this.state.address);
			newAddress[field] = val;
			// TODO: clearing all validation is not quite right. Do we want fully
			// working validation in these modals?
			this.setState({
				address: newAddress,
				validation: null,
				invalidAddressGroup: false,
				errorMessage: null,
			});
		},

		update: function() {
			this.setState({
				isLoading: true,
				validation: null,
			});
			this.props.onUpdate(this.state.address);
		},

		getKeyHandler: function(f) {
			return evt => {
				if (evt.which === 13) {
					f();
				}
			};
		},

		render: function() {
			const {addressType, className} = this.props;
			const {address, isLoading} = this.state;
			const addressToShow = this.props.initialAddress;
			let linesEl;
			if (!addressToShow.address1) {
				linesEl = <span>{"No address on file."}</span>;
			} else {
				const lines = BookstoreUtil.formatAddressFromData(addressToShow);
				linesEl = lines.map((line, i) => {
					return (
						<span key={"line" + i}>
							{line}
							<br />
						</span>
					);
				});
			}

			let editModal = null;
			if (this.state.isModalOpen) {
				let saveButton = (
					<div
						className={styles.button}
						onClick={this.update}
						onKeyPress={this.getKeyHandler(this.update)}
						tabIndex={100}
					>
						Save Changes
					</div>
				);
				const cancelButton = (
					<div
						className={styles.button}
						onClick={this.closeModal}
						onKeyPress={this.getKeyHandler(this.closeModal)}
						tabIndex={101}
					>
						Cancel
					</div>
				);
				const errorEl = (
					<div
						className={
							this.state.errorMessage ? styles.error : styles.errorHidden
						}
					>
						{this.state.errorMessage}
					</div>
				);
				if (isLoading) {
					saveButton = (
						<div className={styles.loadingContainer}>
							<div className={styles.loading}>
								<LoadingCircle colorType="white" />
							</div>
						</div>
					);
				}
				editModal = (
					<OfficeModal
						onClose={this.closeModal}
						closeOnEsc={true}
						portalContainer={PORTAL_CONTAINERS.EDITABLE_MODAL}
						level="overBar"
						modalClass={styles.modal}
						isScrollable={true}
						scrollTopOnOpen={true}
					>
						<div className={styles.title}>
							{`Update ${_.capitalize(addressType)} Address`}
						</div>
						<Information
							values={address}
							updateField={this.updateField}
							className={styles.information}
							addressType={addressType}
							invalidAddressGroup={this.state.invalidAddressGroup}
							errorFields={this.state.validation}
							initialTabIndex={1}
						/>
						{errorEl}
						<div className={styles.buttonRow}>
							{saveButton}
							{cancelButton}
						</div>
					</OfficeModal>
				);
			}

			let mainClass = styles.main;
			if (className) mainClass += " " + className;

			return (
				<div className={mainClass}>
					<EditPencil onClick={this.openModal} />
					<div className={styles.address}>{linesEl}</div>
					{editModal}
				</div>
			);
		},
	})
);
